'use client';

import { SidebarTrigger, useSidebar } from '@/components/ui/sidebar';

/**
 * The shared collapse rail — the narrow vertical strip between the left nav and
 * the page content that holds the sidebar-collapse toggle. Rendered once by the
 * unified top-level shell (`LayoutWrapper`) for every top-level page (Matters,
 * Scribe, Intake, Templates), so the rail width is single-sourced and can't
 * drift (LF-5279).
 *
 * Mobile-only (VALE-544): below the nav-collapse breakpoint it's the only way
 * to open the nav drawer, so it renders exactly as before. At desktop widths
 * the global nav is permanently visible (there is nothing to collapse it into
 * — see the keyboard-shortcut gate in `sidebar/provider.tsx`), so the rail
 * would hold nothing but dead space; render nothing instead.
 */
export function CollapseRail() {
  const { isMobile } = useSidebar();

  if (!isMobile) return null;

  return (
    <div className="bg-card flex w-8 shrink-0 flex-col pl-1.5">
      <div className="pt-4">
        <SidebarTrigger />
      </div>
    </div>
  );
}
